import React, { useState } from 'react'
// import { useDispatch } from 'react-redux'

import {
  Grid, FormLabel, Fab, Paper, Dialog,
  DialogTitle as MuiDialogTitle, Typography,
  IconButton, DialogContent as MuiDialogContent
} from '@material-ui/core'

import CloseIcon from '@material-ui/icons/Close'
import TopWebsitesIcon from '@material-ui/icons/Assignment'
import TopUsersIcon from '@material-ui/icons/AssignmentInd'
import TopPhrasesIcon from '@material-ui/icons/AssignmentLate'

import { makeStyles } from '@material-ui/core/styles'

import UsersReport from '../reports/UsersReport'
import WebsitesReport from '../reports/WebsitesReport'
import PhrasesReport from '../reports/PhrasesReport'
import SupervisorActivityReport from '../reports/SupervisorActivityReport'
import SupervisorLoginReport from '../reports/SupervisorLoginReport'

const useStyles = makeStyles((theme) => ({
  backBtn: {
    backgroundColor: '#8BB84B',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#588518'
    }
  },
  deleteBtn: {
    backgroundColor: theme.palette.action.active,
    margin: 'auto',
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.error.light
    }
  },
  greenBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    },
    borderRadius: '50%'
  },
  blueBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  blueBackground: {
    backgroundColor: '#007BFF',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  greenBackground: {
    backgroundColor: '#97b557',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  greyColor: {
    color: '#0000008A'
  },
  editPaper: {
    backgroundColor: '#ffffff',
    maxHeight: '50em',
    overflow: 'scroll'
  },
  wordList: {
    width: '100%'
  },
  customText: {
    textTransform: 'none !important',
    marginTop: '1rem'
  },
  tableContainer: {
    height: 'auto'
  },
  tablePaper: {
    height: '60vh',
    overflow: 'scroll'
  },
  tableText: {
    fontWeight: 'bold',
    color: '#A4D164'
  },
  tableHeadText: {
    fontWeight: 'bold',
    color: '#007bff'
  },
  table: {
    height: 250
  },
  navBtn: {
    color: '#fff',
    backgroundColor: '#A4D164',
    '&:hover': {
      backgroundColor: '#8AB651'
    },
    borderRadius: '50%',
    width: '80px',
    height: '80px'
  },
  icon: {
    fontSize: '3rem'
  },
  greenText: {
    color: '#97b557'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
}))

/**
 * Creates a modal that displays reports
 */
const ReportsModal = ({ toggleModal, open }) => {
  const classes = useStyles()

  const [selectedForm, setSelectedForm] = useState('problem-users')

  function getSelectedForm () {
    return (
      <>
        {(() => {
          switch (selectedForm) {
            case 'problem-users':
              return <UsersReport setSelectedForm={setSelectedForm} classes={classes} />
            case 'problem-phrases':
              return <PhrasesReport setSelectedForm={setSelectedForm} classes={classes} />
            case 'problem-websites':
              return <WebsitesReport setSelectedForm={setSelectedForm} classes={classes} />
            case 'supervisor-report':
              return <SupervisorActivityReport setSelectedForm={setSelectedForm} classes={classes} />
            case 'supervisor-login-report':
              return <SupervisorLoginReport setSelectedForm={setSelectedForm} classes={classes} />
            default:
              return null
          }
        })()}
      </>
    )
  }

  function renderButtons () {
    return (
      <Grid container item direction='column' justify='flex-start' className='mr-4 ml-2' xs={2}>
        <Paper elevation={2}>
          <Grid
            container
            direction='column'
            justify='center'
            className='w-100 p-1 mx-auto my-auto'
            spacing={2}
          >
            <Grid item container direction='row' justify='center' className='mt-1'>
              <Grid item container direction='column'>
                <Grid item container direction='row' justify='center'>
                  <Fab
                    className={classes.navBtn}
                    onClick={(e) => { e.preventDefault(); setSelectedForm('problem-users') }}
                  >
                    <TopUsersIcon className={classes.icon} />
                  </Fab>
                </Grid>
                <Grid item container direction='row' justify='center'>
                  <FormLabel className={classes.customText}>Captures By User</FormLabel>
                </Grid>
              </Grid>
            </Grid>

            <Grid item container direction='row' justify='center'>
              <Grid item container direction='column'>
                <Grid item container direction='row' justify='center'>
                  <Fab
                    className={classes.navBtn}
                    onClick={(e) => { e.preventDefault(); setSelectedForm('problem-phrases') }}
                  >
                    <TopPhrasesIcon className={classes.icon} />
                  </Fab>
                </Grid>
                <Grid item container direction='row' justify='center'>
                  <FormLabel className={classes.customText}>Top Phrases</FormLabel>
                </Grid>
              </Grid>
            </Grid>

            <Grid item container direction='row' justify='center'>
              <Grid item container direction='column'>
                <Grid item container direction='row' justify='center'>
                  <Fab
                    className={classes.navBtn}
                    onClick={(e) => { e.preventDefault(); setSelectedForm('problem-websites') }}
                  >
                    <TopWebsitesIcon className={classes.icon} />
                  </Fab>
                </Grid>
                <Grid item container direction='row' justify='center'>
                  <FormLabel className={classes.customText}>Top Websites</FormLabel>
                </Grid>
              </Grid>
            </Grid>

          </Grid>
        </Paper>
      </Grid>
    )
  }

  return (
    <div>
      <Dialog open={open} onClose={toggleModal} className='filterModal' fullWidth maxWidth='lg'>
        <MuiDialogTitle disableTypography>
          <Typography variant='h4' color='primary' classes={{ colorPrimary: classes.greenText }} className='font-weight-bold'>Reports</Typography>
          <IconButton aria-label='close' className={classes.closeButton} onClick={toggleModal}>
            <CloseIcon />
          </IconButton>
        </MuiDialogTitle>
        <MuiDialogContent dividers>
          <Grid item container direction='row' justify='center'>

            {renderButtons()}

            <Grid item container direction='column' xs={9}>
              {getSelectedForm()}
            </Grid>
          </Grid>
        </MuiDialogContent>
      </Dialog>
    </div>
  )
}

export default ReportsModal
